import { REACT_APP__URL_DATAFAN_BASE } from "@smp/utils";
import { apiRequestDatafan } from "../_helpers";
export const ApiDatafanProject = {
    Pipelines: {
        list: (projectId, query, next) => {
            var _a, _b, _c, _d;
            return apiRequestDatafan({
                endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/pipelines/`,
                method: "GET",
                next,
                query: {
                    filtered: JSON.stringify([
                        {
                            columnName: "project_id",
                            value: [projectId],
                        },
                        ((_b = (_a = query === null || query === void 0 ? void 0 : query.filter) === null || _a === void 0 ? void 0 : _a.source) === null || _b === void 0 ? void 0 : _b.length)
                            ? {
                                columnName: "source",
                                value: query.filter.source,
                            }
                            : undefined,
                        ((_c = query === null || query === void 0 ? void 0 : query.filter) === null || _c === void 0 ? void 0 : _c.name)
                            ? {
                                columnName: "name",
                                value: query.filter.name,
                            }
                            : undefined,
                    ].filter(Boolean)),
                    id__in: (_d = query === null || query === void 0 ? void 0 : query.id__in) === null || _d === void 0 ? void 0 : _d.join(","),
                    lang: query === null || query === void 0 ? void 0 : query.lang,
                    limit: query === null || query === void 0 ? void 0 : query.limit,
                    offset: query === null || query === void 0 ? void 0 : query.offset,
                    ordering: "-id",
                },
            });
        },
    },
    list: (query) => apiRequestDatafan({
        endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/project/`,
        method: "GET",
        query: {
            lang: query === null || query === void 0 ? void 0 : query.lang,
            special_external_id: query === null || query === void 0 ? void 0 : query.special_external_id,
            special_subowner: "smmplanner",
        },
    }),
};
//# sourceMappingURL=project.js.map